// AI Role Transformation agent — domain model
import { ToolActivity } from '../../pcheck/models/pcheck.model';

export type { ToolActivity };

export interface DownloadItem {
  filename: string;
  url: string;
  docType: string;
}

/** Fields the AiRoleRendererComponent reads from a ChatMessage. */
export interface AiRoleChatMessage {
  content: string;
  /** True while the agent is still streaming tokens. */
  isThinking?: boolean;
  toolActivity?: ToolActivity[];
  downloads?: DownloadItem[];
}

/** All user interactions from the AiRoleRenderer funneled through a single output. */
export interface AiRoleAction {
  type: 'send-message';
  payload: string;
  msgIdx: number;
}

/** Strips the "What would you like to do next?" footer from agent messages so
 *  it doesn't render as raw text alongside the pill buttons. */
export const FOOTER_PATTERN =
  /([-–—]{2,}\s*\n?)?What would you like to do next\?[\s\S]*$/i;

/** Quick-action pill buttons — mirror the old platform's NEXT_ACTIONS. */
export const NEXT_ACTIONS: { label: string; icon: string; value: string }[] = [
  { label: 'Share my role',     icon: 'pi-user',      value: '1' },
  { label: 'AI Wins Dashboard', icon: 'pi-chart-bar', value: '2' },
  { label: 'Human Value',       icon: 'pi-users',     value: '3' },
  { label: 'AI-Forward JD',     icon: 'pi-file-edit', value: '4' },
  { label: '30/60/90 Plan',     icon: 'pi-calendar',  value: '5' },
  { label: 'All four',          icon: 'pi-bolt',      value: '6' },
];

/** Human-readable labels and PrimeNG icons for each AI role tool. */
export const TOOL_DISPLAY: Record<string, { label: string; icon: string }> = {
  extract_jd_from_upload:        { label: 'Reading Job Description',         icon: 'pi-file-import' },
  get_role_profile_template:     { label: 'Loading Role Profile',            icon: 'pi-id-card' },
  generate_ai_wins_dashboard:    { label: 'Generating AI Wins Dashboard',    icon: 'pi-chart-bar' },
  generate_human_value_analysis: { label: 'Generating Human Value Analysis', icon: 'pi-users' },
  generate_ai_forward_jd:        { label: 'Generating AI-Forward JD',        icon: 'pi-file-edit' },
  generate_transformation_plan:  { label: 'Generating Transformation Plan',  icon: 'pi-calendar' },
};

/** Icon name for each document type — used on download buttons. */
export const DOC_TYPE_LABELS: Record<string, string> = {
  ai_wins_dashboard:    'AI Wins Dashboard (.xlsx)',
  human_value_analysis: 'Human Value Analysis',
  ai_forward_jd:        'AI-Forward Job Description (.docx)',
  transformation_plan:  '30/60/90 Day Plan (.pptx)',
};
